import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Header from "../../Header";
import Sidebar from "../../Sidebar";
import Footer from "../../Footer";
import AppListDetails from "./AppListDetails";

/**
 * Tenant-scoped Apps list (Phase 3A: MUI shell). Legacy wrapper divs
 * (`.container-scroller`, `.page-body-wrapper`, `.main-panel`,
 * `.content-wrapper`) are gone — the MUI AppBar + Drawer + Footer
 * handle layout via the shellLayout.css shim for pages that still
 * use them, and MUI Box + Container handle this page directly.
 */
const Applist = () => {
    return (
        <>
            <div className="container-scroller">
                <Header />
                <div className="container-fluid page-body-wrapper">
                    <Sidebar />
                    <Box component="main" className="main-panel" sx={{ display: "flex", flexDirection: "column" }}>
                        <Box sx={{ flex: 1, py: { xs: 2, md: 3 } }}>
                            <Container maxWidth="xl" disableGutters sx={{ px: { xs: 2, md: 3 } }}>
                                <AppListDetails from={"Apps"} organizationId={null} />
                            </Container>
                        </Box>
                        <Footer />
                    </Box>
                </div>
            </div>
        </>
    );
};

export default Applist;
